import { observer } from 'mobx-react-lite'

import { EventIcon, TextArea } from 'components'
import { useValueContext } from 'contexts'
import { FlexLayout } from 'layouts'
import { EventType } from 'types'

import { CurrentDateError, Duration, TimeInputs, Volume } from '../../components'
import { iconProps } from '../consts'
import './styles.scss'

const labels = ['Смесь', 'Молоко']

interface Props {
  current?: boolean
}

export const Bottle = observer(({ current }: Props) => {
  const { eventStore } = useValueContext()
  const { event, setEventField, validFunctions } = eventStore

  const isDurationValid = validFunctions[EventType.BOTTLE]

  return (
    <>
      <div className="page-title event-title">Бутылочка</div>
      <FlexLayout.Content className="scrollable-layout event-scrollable" scrollable>
        <div className="bottle-event">
          <div className="type-icons">
            <EventIcon iconName="FeedBottleIcon" {...iconProps} />
          </div>
          <TextArea
            className="event-textarea"
            label="Комментарий"
            placeholder="Например, сцеженное молоко"
            value={event?.comment}
            onChange={(value: string) => setEventField('comment', value)}
            scrollToOnFocus
          />
          <div className="quick-labels">
            {labels.map((it) => (
              <div className="label" key={it} onClick={() => setEventField('comment', it)}>
                {it}
              </div>
            ))}
          </div>
          <Volume
            step={10}
            value={event?.volume || 0}
            onChange={(value: string | number) => setEventField('volume', value)}
            scrollToOnFocus
          />
          <div className="time-grid">
            <TimeInputs
              label="Начало"
              value={event?.startTime}
              onChange={(value: string) => setEventField('startTime', value)}
              selectTimeOnRender={current}
              eventType="START"
            />
            <CurrentDateError />
            {!current && (
              <>
                <TimeInputs
                  label="Конец"
                  value={event?.endTime}
                  onChange={(value: string) => setEventField('endTime', value)}
                  eventType="END"
                />
                <Duration
                  isValid={isDurationValid()}
                  startTime={event?.startTime}
                  endTime={event?.endTime}
                />
              </>
            )}
          </div>
        </div>
      </FlexLayout.Content>
    </>
  )
})
